import React from 'react';
import { symbol, oneOfType, node, bool } from 'prop-types';

const SelectItem = ({ selected, disabled, value, children, ...props }) => (
  <li
    tabIndex="0"
    className="mdc-list-item"
    role="option"
    aria-disabled={disabled}
    aria-selected={selected}
    {...props}
  >
    {children}
  </li>
);

SelectItem.propTypes = {
  selected: bool,
  disabled: bool,
  children: node.isRequired,
  value: oneOfType([
    node,
    symbol,
  ]).isRequired,
};

SelectItem.defaultProps = {
  selected: false,
  disabled: false,
};

export default SelectItem;
